import { Master } from "../model/masters.model";

export const baseURL = '/';
export const appName = process.env.REACT_APP_NAME ?? 'My Application';


export const YES_NO_OPTIONS: Array<Master> = [
 { id: 'Y', name: 'Yes' },
 { id: 'N', name: 'No' },
];